import createReactClass from "create-react-class";
import React from "react";
import { ControlLabel } from "react-bootstrap";
import { ServerActions } from "../actions/serverActions";
import { SubdivisionActions } from "../actions/subdivisionActions";
import Constants from "../constants/constants";
import { restrictionRequestStore } from "../stores/restrictionRequest";
import { subdivisionStore } from "../stores/subdivision";
import { territoryStore } from "../stores/territory";
import { userStore } from "../stores/user";

//function to get state from store, getting the currently loaded formb
function getStateFromStores() {
  return {
    selectableSubList: subdivisionStore.getSubList(),
    entireSubList: subdivisionStore.getEntireSubList(),
    ptcSubList: subdivisionStore.getPtcSubdivisionList(),
    selectedSub: subdivisionStore.getSelectedSub(),
    subData: subdivisionStore.getSubData(),
    isSubSelected: subdivisionStore.isSubSelected(),
    subsForTerritory: subdivisionStore.getSubList(),
    userType: userStore.getSelectedRole(),
    isDispatcher: userStore.isDispatcher(),
    isTerLoading: territoryStore.isLoading(),
    selectedTerritory: territoryStore.getSelectedTerritory(),
    isDirty: restrictionRequestStore.isDirty(),
  };
}

export const SubdivisionView = createReactClass({
  componentDidMount: function () {
    subdivisionStore.subscribe(this._onChange);
    ServerActions.getSubdivisionList();
    ServerActions.getPtcSubdivisionList();
    ServerActions.getDivisionList();
    territoryStore.subscribe(this._onChange);
    userStore.subscribe(this._onChange);
    restrictionRequestStore.subscribe(this._onChange);
  },

  componentWillUnmount: function () {
    subdivisionStore.unsubscribe(this._onChange);
    territoryStore.unsubscribe(this._onChange);
    userStore.unsubscribe(this._onChange);
    restrictionRequestStore.unsubscribe(this._onChange);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  onSubSelectChange: function (event) {
    $(".searchId").each(function (item, elem) {
      $(elem).val("");
    });

    var val = event.target.value;
    if (this.state.isDirty) {
      window
        .confirm("Confirm Subdivision Change", {
          description:
            "Changing subdivisions will abandon all of your current work. Are you sure you want to do this?",
          confirmLabel: "Change to " + event.target.value,
          abortLabel: "Go Back",
        })
        .then(function () {
          SubdivisionActions.selectChanged(val);
        });
    } else {
      SubdivisionActions.selectChanged(val);
    }
  },

  //modify this to return the formBform view markup
  render: function () {
    var subdivisions = [];
    var disableSubSelector = true;
    var selectText = "Select...";
    if (this.state.isTerLoading) {
      disableSubSelector = true;
      selectText = "Loading...";
    }
    if (this.state.selectableSubList) {
      subdivisions = this.state.selectableSubList.map(function (sub, i) {
        let displayName = sub.name;
        if (displayName == Constants.UISubDivisions.UI_LAKES_OLD) {
          displayName = Constants.UISubDivisions.UI_LAKES_NEW;
        } else if (displayName == Constants.UISubDivisions.UI_LAKESI_OLD) {
          displayName = Constants.UISubDivisions.UI_LAKESI_NEW;
        }

        // if (ptcSubs.indexOf(displayName) > -1) {
        //     displayName += ' (P)'
        // }
        return (
          <option key={i + 1} value={sub.name}>
            {displayName}
          </option>
        );
      });
      subdivisions.splice(
        0,
        0,
        <option disabled key={0} value="0">
          {selectText}
        </option>
      );
    }

    if (subdivisions.length > 1) {
      disableSubSelector = false;
    }

    return (
      <div>
        <ControlLabel style={{ color: "gray" }}>Sub:</ControlLabel>{" "}
        <select
          id="subdivisionSelect"
          disabled={disableSubSelector}
          value={this.state.selectedSub}
          onChange={this.onSubSelectChange}
        >
          {subdivisions}
        </select>
      </div>
    );
  },
});
